import "../style/azmoon-list/AzmoonList.css";
import ALCurrentExams from "./AL_CurrentExams";
import ALFilter from "./AL_Filter";
import ALPastExams from "./AL_PastExams";
import ALSearch from "./AL_Search";
import ALSearchTag from "./AL_SearchTag";
import { useSelector } from "react-redux";
// import Exam from "./Exam";

const AzmoonList = () => {
  const state = useSelector((state) => state.default);
  // const [openNav_is_change,set_openNav_is_change]=useState(false);

  if (state.openNav === "open") {
    document
      .querySelector(".AzmoonList-main")
      .classList.add("AzmoonList-main-won");
  } else if (state.openNav === "close") {
    if (document.querySelector(".AzmoonList-main") !== null) {
      document
        .querySelector(".AzmoonList-main")
        .classList.remove("AzmoonList-main-won");
    }
  }

  return (
    <div className="AzmoonList">
      <div className="AzmoonList-main">
        <ALSearch />
        <ALSearchTag />
        <div className="AzmoonList-main-line"></div>
        <ALFilter />
        <ALCurrentExams />
        <ALPastExams />
      </div>
      {/* <Exam/> */}
    </div>
  );
};

export default AzmoonList;
